import RedefineSenha from "../../componentes/RedefineSenha";

const ResetSenha = () => {
    return (
        <div>
            <RedefineSenha />
        </div>
    );
}
export default ResetSenha;